module.exports = __webpack_public_path__ + "img/17.7d5d2f2.png";